const install = (Vue) => {
  const requireContext = require.context('.', true, /\.vue/);
  requireContext.keys().forEach((path) => {
    // 每个文件的详细信息
    const file = requireContext(path);
    if (file.default.name) {
      Vue.component(file.default.name, file.default);
    } else {
      console.error(`请给组件${path}加上name属性`);
    }
  });
};

export default {
  install
};
